import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'megabytes',
})
export class MegabytesPipe implements PipeTransform {
  transform(value: number): string {
    return `${(value / 1048576).toFixed(2).replace('.', ',')} MB`;
  }
}
